/**
 * Created by fwt on 2019-3-13.
 */
import React, {Component} from 'react';
import {Modal, Toast} from 'antd-mobile';
import {getShiftDetail,newWxPay} from '../../../service/homeService';
import {getChangePic,changeSubmit} from '../../../service/orderService';
import PayModal from "../../../components/PayModal";
import "./style.less";
import {connect} from "react-redux";
const cardSfz = require('../../../common/image/cardSfz.png');
const invoice = require('../../../common/image/invoice.png');
const refund = require('../../../common/image/refund.png');
const box = require('../../../common/image/box.png');
const child = require('../../../common/image/child.png');
const yixuan = require('../../../common/image/yixuan.png');
const kexuan = require('../../../common/image/kexuan.png');
const xuanzhong = require('../../../common/image/xuanzhong.png');
let isSubmit = false;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class OrderChange extends Component {
    constructor(props) {
        super(props);
        if (isSubmit) {
            isSubmit = false;
            props.history.goBack();
        }
        this.state = {
            noticeModal:false,
            seatList:[],
            picData:[],
            priceTotal:0,
            seatSelIndex:'',
            priceSpread:0,
            seatData: [],
            currentSeat:false,
            payModal:false,
            payData:"",
            formPay:"",
        };
    }

    componentDidMount() {
        // console.log(this.props);
        let props = this.props.location.state;
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                id:props.id,//班次id
                startStationId:props.startStationId,//出发站点id
                startPosition:props.startPosition,//出发经纬度
                startAddress:props.startAddress,//出发具体地址
                endStationId:props.endStationId,
                endPosition:props.endPosition,
                endAddress:props.endAddress,
            },
        };
        Toast.loading('正在加载',0);
        getShiftDetail(params).then((res)=>{
            if(res.data.code === '0000'){
                res.data.data.seatList.map((r)=>{
                    r.actualPrice = r.totalPrice;
                    r.flag = false;
                });
                this.setState({seatData:res.data.data,seatList:res.data.data.seatList});
                Toast.hide();
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    reserveModal(){
        let flag = false;
        this.state.seatList.map((res)=>{
            if(res.flag){
                flag = true
            }
        });
        if(flag == false){
            Toast.info("请选择座位");
            return
        }

        this.setState({noticeModal: true});
    }
    //乘车须知
    orderSubmit = () => {
        return (
            <Modal
                className="noticeModal"
                visible={this.state.noticeModal}
                transparent
                closable={true}
                maskClosable={false}
                onClose={()=>this.setState({noticeModal:false})}
                footer={[{text: '知道了', onPress: () => this.reserve()}]}
            >
                <div className="passengerTips">
                    <div>订座须知</div>
                    <div className="column">
                        <img src={cardSfz}/>
                        <div>根据交管局要求，乘客上车必须<span>携带身份证</span>，司机需要身份证进行 <span>扫描识别。</span></div>
                    </div>
                    <div className="column">
                        <img src={child}/>
                        <div><span>携带宠物</span>需购票前与客服联系。</div>
                    </div>
                    <div className="column">
                        <img src={box}/>
                        <div>每张全票允许携带<span>小于20kg</span>的行李物品（特殊占位置的物品除外），超过20kg请自行托运。</div>
                    </div>
                    <div className="column">
                        <img src={refund}/>
                        <div>距发车时间2小时内退票收取<span>50%</span>手续费，不允许改签；2-12小时退票、改签<span>20%</span>；12-24为<span>10%</span>；24小时以上退票<span>5%</span>、改签<span>0.01元</span>。
                        </div>
                    </div>
                    <div className="column">
                        <img src={invoice}/>
                        <div>电子发票免费开具，纸质发票收取10元邮寄费用；特殊要求请在发票申请备注内填写说明。<span>收取10元</span>邮寄费用；特殊要求请在发票申请备注内填写说明。</div>
                    </div>
                </div>
            </Modal>
        )
    };

    reserve(){
        let props = this.props.location.state;
        let currentSeat = {};
        this.state.seatList.map((res)=>{
            if(res.flag){
                currentSeat = res;
            }
        });
        let params={
            source: 1,
            token:this.props.userInfo.token,
            data:{
                id:props.orderId,
                shiftId:this.state.seatData.id,
                lineId:this.state.seatData.lineId,
                startPosition:props.startPosition,//出发经纬度
                endPosition:props.endPosition,
                startStationId:props.startStationId,//出发站点id
                endStationId:props.endStationId,
                startAddress:props.startAddress,//出发具体地址
                endAddress:props.endAddress,
                startCity:this.state.seatData.startCity,
                endCity:this.state.seatData.endCity,
                seatId:currentSeat.id,
                seatPrice:currentSeat.seatPrice,
                pickUpPrice:currentSeat.pickUpPrice,
                deliveryPrice:currentSeat.deliveryPrice,
                charge:this.state.picData.charge,
                differencePrice:this.state.picData.differencePrice,
                endorseSource:9,
            }
        };
        // console.log(params);
        // return
        Toast.loading("",0);
        changeSubmit(params).then((res)=>{
            if(res.data.code === '0000'){
                Toast.hide();
                if(this.state.priceTotal == 0){
                    isSubmit = true;
                    this.props.history.go(-2)
                    // this.props.history.push(`/pay/myOrder`,);
                }else{
                    this.setState({payModal:true,payData:res.data.data,noticeModal: false});
                }
            }else{
                this.setState({noticeModal: false});
                Toast.info(res.data.msg+"请稍后重试",3);
            }
        })
    }
    payType(e){
        if(e == ""){
            Toast.info("请选择支付方式");
            return
        }
        if(e == "工商银行支付"){
            this.weiXinPay(this.state.payData,"icbcjft");
        }
        if(e== "微信支付"){
            this.weiXinPay(this.state.payData,"wx");
        }
        if(e == "民途钱包余额支付"){
            this.weiXinPay(this.state.payData,"wallet");
        }
    }
    weiXinPay = (orderNo,type) => {
        Toast.loading("",0);
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                source: 1,
                orderId: orderNo,
                payChannel:type,
            }
        };
        newWxPay(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                if(type == "wx"){
                    this.wxBridgeReady(res.data.data);
                }else if(type == "wallet"){
                    isSubmit = true;
                    this.props.history.go(-2)
                }else{
                    isSubmit = true;
                    // window.location.href = res.data.data.qrcode;
                    this.setState({formPay:res.data.data,});
                }
            } else {
                // this.setState({noticeModal: false});
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
            console.log(error);
        })
    };
    wxBridgeReady = (bridgeInfo,) => {
        const self = this;

        function onBridgeReady() {
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId": bridgeInfo.appId,         //公众号名称，由商户传入
                    "timeStamp": bridgeInfo.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": bridgeInfo.nonceStr,   //随机串
                    "package": bridgeInfo.package,     //prepay_id
                    "signType": bridgeInfo.signType,   //微信签名方式
                    "paySign": bridgeInfo.sign         //微信签名
                },
                function (r) {
                    // alert(JSON.stringify(r));
                    if (r.err_msg === "get_brand_wcpay_request:ok") {
                        isSubmit = true;
                        // self.props.history.push(`/pay/myOrder`,);
                        self.props.history.go(-2)
                    } else if (r.err_msg === "get_brand_wcpay_request:cancel") {
                        Toast.info('您取消了支付，可到订单详情支付', 2, () => {
                            isSubmit = true;
                            // self.props.history.push(`/pay/myOrder`,);
                            self.props.history.go(-2)
                        });
                    } else if (r.err_msg === "get_brand_wcpay_request:fail") {
                        Toast.info('支付失败，请稍后重试', 2, () => {
                            isSubmit = true;
                            // self.props.history.push(`/pay/myOrder`,);
                            self.props.history.go(-2)
                        });
                    }
                }
            );
        }

        if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
    };
    //选座位/更换
    selSeat(i,r) {
        let priceTotal = 0;
        let props = this.props.location.state;
        if (r.status === 1) {
            Toast.loading("",0);
            let params={
                source: 1,
                token:this.props.userInfo.token,
                data:{
                    startStationId:props.startStationId,//出发站点id
                    startPosition:props.startPosition,//出发经纬度
                    endStationId:props.endStationId,
                    endPosition:props.endPosition,
                    seatId:r.id,
                    shiftId:this.state.seatData.id,
                    id:props.orderId
                }
            };
            getChangePic(params).then((res)=>{
                if(res.data.code === '0000'){
                    Toast.hide();
                    priceTotal = res.data.data.charge + res.data.data.differencePrice;
                    this.setState({picData:res.data.data,priceTotal});
                }else{
                    Toast.info(res.data.msg,3);
                }
            });
            r.flag = true;
            this.setState({seatSelIndex:i});
        }
        this.state.seatList.map((res,index)=>{
           if(index !== i){
               res.flag = false;
           }
        });
    }
    onClose = (v) => {
        Toast.info('您取消了支付，可到订单详情支付', 2, () => {
            isSubmit = true;
            this.props.history.go(-2)
        });
    };
    payFrom(){
        if(this.state.formPay !== ""){
            return(
                <form
                    name="auto_submit_form"
                    method="post"
                    action={this.state.formPay.url}>
                    <input
                        type="hidden"
                        name="biz_content"
                        value={this.state.formPay.bizContent} />
                    <input type="submit" value="立刻提交" style={{display:"none"}} onClick={setTimeout(()=>document.forms[0].submit(),100)}/>
                </form>
            )
        }else{
            return null
        }
    }

    render(){
        const {seatData,seatList} = this.state;
        return(
            <div className="orderChange">
                <div className="goBack">
                    <i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />
                </div>

                <div className="warp">
                    <div className="content">
                        <div className="topBar">
                            <div className="city">
                                <span className="start">{seatData.startCity}</span>
                                <div><span>—</span><div className="carNum">{seatData.carNum}</div><span>—</span></div>
                                <span className="end">{seatData.endCity}</span>
                            </div>
                            <div className="time">
                                <span className="">{seatData.startTime}</span>
                                <span className="">{seatData.endTime}</span>
                            </div>
                            <p>{seatData.date} {seatData.weekend} {seatData.pickUpTime}开始接人</p>
                        </div>

                        <div className="selSeat">
                            <div className="seatTop">
                                <span className="title">预定座位</span>
                                <div className="bottom">
                                    <div className="kexuan"><img src={kexuan} />可选</div>
                                    <div className="xuanzhong"><img src={xuanzhong} />选中</div>
                                    <div><img src={yixuan} />被选</div>
                                </div>
                            </div>
                            <div className="seatBottom">
                                <div className="title">
                                    <div>前排</div>
                                    <div className='middle'>中排</div>
                                    <div>后排</div>
                                </div>
                                <div className="seatsBox">

                                    <div className="selected">
                                        <img src={yixuan} />
                                        <span>司机</span>
                                    </div>
                                    {
                                        seatList.map((res, i) => {
                                            return(
                                                <div
                                                    key={i}
                                                    className={res.status !== 1 ? 'selected' : res.status === 1 && res.flag === false ? '' : 'sel' }
                                                    style={i > seatList.length - 4 ? {width: '31.33%'} : {}}
                                                    onClick={() => this.selSeat ? this.selSeat(i,res) : null}
                                                >
                                                    {res.status !== 1 ? <img alt="" src={yixuan} /> : res.status === 1 &&  res.flag === false ? <img alt="" src={kexuan} /> :  <img alt="" src={xuanzhong} />}
                                                    <span>{'￥'+res.totalPrice}</span>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>

                        </div>

                        {
                            this.state.picData == "" ? null : (
                                <div className="picDetails">
                                    <div className="tit">价格明细</div>
                                    <div className="oldOrder">
                                        <span className="tit">原订单:</span>
                                        <span>￥{this.state.picData.originalPrice}</span>
                                    </div>
                                    <div className="oldOrder">
                                        <span className="tit">手续费:</span>
                                        <span>￥{this.state.picData.charge}</span>
                                    </div>
                                    <div className="oldOrder">
                                        <span className="tit">差价:</span>
                                        <span>￥{this.state.picData.differencePrice}</span>
                                    </div>
                                </div>
                            )
                        }

                    </div>
                </div>




                <div className="footer">
                    <div className="payTotal">合计：
                        <span>￥{parseFloat(this.state.priceTotal).toFixed(2)}</span>
                    </div>
                    <button className="go" onClick={() => this.reserveModal()}>确认改签</button>
                </div>

                {this.orderSubmit()}
                <PayModal
                    modal={this.state.payModal}
                    onClose={this.onClose.bind(this)}
                    payType={this.payType.bind(this)}
                />
                {this.payFrom()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Order/OrderChange/index.js